var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-container",class:[_vm.position, _vm.size]},[_c('div',{staticClass:"progress-label"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"progress-track"},[_c('div',{staticClass:"progress-fill",style:({
        width: _vm.value,
        background: `linear-gradient(90deg, ${_vm.color} 0%, ${_vm.color}dd 100%)`,
      })}),_c('div',{staticClass:"progress-glow",style:({
        width: _vm.value,
        background: `linear-gradient(90deg, ${_vm.color}40 0%, transparent 100%)`,
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }